import React from 'react';
import styled from 'styled-components';
import redirectAppURL from '@common/redirectApp';
import breakpointsMinWidth from '../../../../../../cra/src/styling/breakpointsMinWidth';
import { Button } from '../heroNew/shared/centerContent/components';

const HeroContainer = styled.section`
  background: #f8f6ff;
  padding-top: 56px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 22px 34px 40px 34px;

  @media ${breakpointsMinWidth.tabletSm} {
    padding: 24px 48px 40px 48px;
  }
  @media ${breakpointsMinWidth.tabletMd} {
    padding: 24px 75px 48px 75px;
    flex-direction: row;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    gap: 20px;
    padding: 28px 100px 48px 107px;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    padding: 32px 115px 48px 121px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    flex-direction: row;
    gap: 18px;
    padding: 36px 162px 55px 162px;
  }
`;

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: left;
  color: white;
  width: 100%;

  @media ${breakpointsMinWidth.tabletMd} {
    padding-top: 20px;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    padding-top: 24px;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    padding-top: 24px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    padding-top: 36px;
  }
`;

const Title = styled.div`
  font-size: 28px;
  line-height: 1.16;
  font-weight: 500;
  background: linear-gradient(180deg, #2364eb, #8510df);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  align-items: center;
  justify-content: center;

  @media ${breakpointsMinWidth.tabletLg} {
    font-size: 36px;
    line-height: 1.16;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    font-size: 40px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 48px;
  }
`;

const SubTitle = styled.div`
  font-size: 14px;
  line-height: 1.4;
  font-weight: 300;
  background: linear-gradient(180deg, #2364eb, #8510df);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  align-items: center;
  justify-content: center;

  @media ${breakpointsMinWidth.tabletLg} {
    font-size: 16px;
    line-height: 1.125;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    font-size: 18px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 20px;
  }
`;

const GradientBorder = styled.div`
  background: linear-gradient(
    90deg,
    rgba(133, 16, 223, 0.3) 0%,
    rgba(35, 100, 235, 0.3) 100%
  );
  padding: 8px;
  border-radius: 20px;
  display: inline-block;
  margin: 0 auto;
  width: 100%;
  height: 193px;
  margin-top: 10px;

  @media ${breakpointsMinWidth.tabletSm} {
    height: 330px;
    padding: 18px;
  }
  @media ${breakpointsMinWidth.tabletMd} {
    height: 430px;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    height: 529px;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    width: 80%;
    height: 475px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    width: 80%;
    height: 632px;
  }
`;

const ImageBox = styled.div`
  background-color: #e7e3fc;
  border-radius: 12px;
  height: 100%;
  width: 100%;
  margin: 0 auto;
`;

const StyledImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
  transition: transform 0.3s ease;
`;

function HeroFeature({ appType, data }) {
  const {
    title = 'Resume Builder - Brains, Beauty, and Bullet Points',
    subTitle = 'Your resume should look sharp and sound smarter. Our AI balances design and substance so you can impress before you even say a word.',
    src = 'https://wallpapers.com/images/featured/beautiful-scenery-wnxju2647uqrcccv.jpg',
    isVideo = false,
    videoSrc = 'https://www.youtube.com/embed/YCSmQzw_83c',
  } = data || {};
  return (
    <HeroContainer>
      <Wrapper>
        <TextContent>
          <Title>{title}</Title>
          <SubTitle>{subTitle}</SubTitle>
          <GradientBorder>
            <ImageBox>
              {!isVideo && (
                <StyledImg
                  src={src}
                  alt={title}
                  className="w-full h-full object-cover rounded-lg"
                />
              )}
              {isVideo && (
                <iframe
                  src={videoSrc}
                  title={title}
                  className="w-full h-full rounded-[12px]"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              )}
            </ImageBox>
          </GradientBorder>
          <Button
            href={redirectAppURL({
              appType,
              path: '/drive/myDrive/?auth=Register',
            })}
            target="_blank"
            className="tabletSm:mt-[8px] tabletMd:!ml-0 tabletLg:!mt-[16px] mx-auto desktopMd:!mt-[24px]"
          >
            TRY FOR FREE
          </Button>
        </TextContent>
      </Wrapper>
    </HeroContainer>
  );
}

export default HeroFeature;
